/* tslint:disable */
/* eslint-disable */

/**
 * Langues
 *
 * 0 = Francais
 * 1 = Anglais
 * 2 = Allemand
 * 3 = Neerlandais
 */
export enum Langues {
  Francais = 0,
  Anglais = 1,
  Allemand = 2,
  Neerlandais = 3
}
